import PropTypes from 'prop-types';
import isArray from 'lodash/fp/isArray';
import isEmpty from 'lodash/fp/isEmpty';
import React, { PureComponent } from 'react';
import './DataTable.scss';

class DataTable extends PureComponent {
  renderHeader = (header, i) => <th key={header}>{header}</th>;

  renderItem = (item, i) => <td key={i}>{item}</td>;

  renderRow = (row, i) => (
    <tr
      key={i}
      className={
        isArray(this.props.rowClassName)
          ? this.props.rowClassName[i]
          : this.props.rowClassName
      }
      onClick={e => this.props.onRowClick && this.props.onRowClick(row, i, e)}
    >
      {row.map(this.renderItem)}
    </tr>
  );

  renderEmpty = (colspan, message) => (
    <tr>
      <td colSpan={`${colspan}`}>{message}</td>
    </tr>
  );

  render() {
    const { headers, rows, emptyMessage } = this.props;
    return (
      <div className={`data-table-container ${this.props.className}`}>
        <table className="data-table">
          <thead>
            <tr>{headers.map(this.renderHeader)}</tr>
          </thead>
          <tbody>
            {!isEmpty(rows) && rows.map(this.renderRow)}
            {isEmpty(rows) && this.renderEmpty(headers.length, emptyMessage)}
          </tbody>
        </table>
      </div>
    );
  }
}

DataTable.propTypes = {
  headers: PropTypes.array,
  rows: PropTypes.array,
  onRowClick: PropTypes.func,
  emptyMessage: PropTypes.string,
  className: PropTypes.string,
  rowClassName: PropTypes.oneOf([PropTypes.string, PropTypes.array]),
};

DataTable.defaultProps = {
  headers: [],
  rows: [],
  emptyMessage: 'NOT FOUND',
  className: '',
};

export default DataTable;
